import React from 'react';

const LoaderIcon = () => (
  <button className="cross-btn">
    <i><img style={{width: '20px'}} src='/images/loader.svg' alt="loader" /></i>
  </button>
);

export default LoaderIcon;